import React, { ChangeEventHandler } from 'react'
import styled from 'styled-components'
import { COLOR } from 'src/constants/colors'

export type CheckBoxPropsType = {
  $margin?: string
  checked: boolean
  onChange?: ChangeEventHandler<HTMLInputElement>
  onMouseDown?: any
  size: '22px' | '20px'
}

const CheckBox = (props: CheckBoxPropsType) => {
  const Size22 = props.size === '22px'

  const CheckSvg = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={Size22 ? '15' : '14'}
        height={Size22 ? '14' : '11'}
        viewBox={`0 0 ${Size22 ? '15' : '14'} 11`}
        fill="none"
      >
        <rect
          x={Size22 ? '0.230957' : '0.846191'}
          y={Size22 ? '4.22656' : '4.52832'}
          width={Size22 ? '2.53846' : '2.30769'}
          height={Size22 ? '8.46154' : '7.69231'}
          rx={Size22 ? '1.26923' : '1.15385'}
          transform={Size22 ? 'rotate(-45 0.230957 4.22656)' : 'rotate(-45 0.846191 4.52832)'}
          fill="white"
        />
        <rect
          x={Size22 ? '12.8384' : '12.3071'}
          y={Size22 ? '0.0986328' : '0.775391'}
          width={Size22 ? '2.53846' : '2.30769'}
          height={Size22 ? '11.8462' : '10.7692'}
          rx={Size22 ? '1.26923' : '1.15385'}
          transform={Size22 ? 'rotate(45 12.8384 0.0986328)' : 'rotate(45 12.3071 0.775391)'}
          fill="white"
        />
      </svg>
    )
  }

  return (
    <CheckboxWrap {...props}>
      <HiddenCheckbox
        type={'checkbox'}
        name={'checkbox'}
        onChange={props.onChange}
        checked={props.checked}
      />
      <StyledCheckbox {...props}>
        <CheckSvg />
      </StyledCheckbox>
    </CheckboxWrap>
  )
}

export default CheckBox

// 체크박스를 감싸는 스타일된 래퍼 컴포넌트
const CheckboxWrap = styled.label<CheckBoxPropsType>`
  position: relative;
  cursor: pointer;
`

// 실제 체크박스를 나타내는 스타일된 input 컴포넌트
const HiddenCheckbox = styled.input`
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
`

// 커스텀 체크박스 아이콘을 나타내는 스타일된 span 컴포넌트
const StyledCheckbox = styled.span<CheckBoxPropsType>`
  display: flex;
  height: ${(props) => props.size};
  width: ${(props) => props.size};
  background-color: ${COLOR.bluegray20};
  border-radius: 6px;
  flex-direction: column;
  justify-content: center;
  position: relative;
  top: 50%;
  transform: translate(0%, -50%);
  > svg {
    margin: 0 auto;
  }
  ${HiddenCheckbox}:checked + & {
    background-color: ${COLOR.black80};
  }
`
